module.exports = __webpack_public_path__ + "img/coming_soon.7627294e.jpg";